import { useCallback } from 'react';

import {
  processData as processClientData,
  useGetClientLite,
} from '../../data/useGetClientLite';
import {
  processData as processJobData,
  useGetJobLinkDetails,
} from '../../data/useGetJobLinkDetails';
import {
  processData as processTaskData,
  useGetTaskLinkDetails,
} from '../../data/useGetTaskLinkDetails';
import { useGetUser } from '../../data/useGetUser';

export function useGetJobLinkText() {
  const getJob = useGetJobLinkDetails({ skip: true });
  const getClient = useGetClientLite({
    skip: true,
  });

  return useCallback(
    async (cloudId: string) => {
      if (!getJob) {
        console.warn(
          'CommentTextRenderer: useGetJobLinkText, getJob is null/undefined',
          { getJob }
        );
        return {
          error: true,
        };
      }
      const jobData = await getJob.refetch({ cloudId });
      const job = processJobData(jobData.data);
      if (jobData.error || !job || !job.clientId) {
        return { error: true };
      }
      if (!getClient) {
        console.warn(
          'CommentTextRenderer: useGetJobLinkText, getClient is null/undefined',
          { getClient }
        );
        return {
          error: true,
        };
      }
      const clientData = await getClient.refetch({
        cloudId: job.clientId,
      });
      const debtor = processClientData(clientData.data);
      if (clientData.error || !debtor) {
        return { error: true };
      }
      return {
        error: false,
        job,
        debtor,
      };
    },
    [getClient, getJob]
  );
}

export function useGetTaskLinkText() {
  const getTask = useGetTaskLinkDetails({
    skip: true,
  });
  const getJob = useGetJobLinkText();

  return useCallback(
    async (cloudId: string) => {
      if (!getTask) {
        console.warn(
          'CommentTextRenderer: useGetTaskLinkText, getTask is null/undefined',
          { getTask }
        );
        return {
          error: true,
        };
      }
      const taskData = await getTask.refetch({ cloudId });
      const task = processTaskData(taskData.data);
      if (taskData.error || !task) {
        return {
          error: true,
        };
      }
      if (!getJob) {
        console.warn(
          'CommentTextRenderer: useGetTaskLinkText, getJob is null/undefined',
          { getJob }
        );
        return {
          error: true,
        };
      }
      const jobData = await getJob(task.jobId || '');
      if (jobData.error || !jobData.debtor || !jobData.debtor) {
        return {
          error: true,
        };
      }
      return {
        error: false,
        task,
        job: jobData.job,
        debtor: jobData.debtor,
      };
    },
    [getTask, getJob]
  );
}

export function useGetUserLinkText() {
  const getUser = useGetUser({ skip: true });

  return useCallback(
    async (cloudId: string) => {
      if (!getUser) {
        console.warn(
          'CommentTextRenderer: useGetTaskLinkText, getUser is null/undefined',
          { getUser }
        );
        return {
          error: true,
        };
      }

      const userData = await getUser.refetch({ cloudId });
      if (userData.error || !userData.data?.getUser) {
        return {
          error: true,
        };
      }
      return {
        error: false,
        user: userData.data.getUser,
      };
    },
    [getUser]
  );
}
